import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { Layout } from '@/components/layout'
import {
  Home,
  Contact,
  About,
  Privacy,
  Terms,
  Cookies,
  SolutionsPage,
  IndustriesPage,
  AssessmentsPage,
  UCaaS,
  CCaaS,
  Network,
  SDWAN,
  Cybersecurity,
  CreditUnions,
  Banking,
  CybersecurityAssessment,
  CloudAssessment,
  NetworkAssessment,
  DataAnalyticsAssessment,
  AIAssessment,
  UCaaSAssessment,
  ContactCenterAssessment,
} from '@/pages'

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          
          {/* Solutions */}
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/solutions/ucaas" element={<UCaaS />} />
          <Route path="/solutions/ccaas" element={<CCaaS />} />
          <Route path="/solutions/network" element={<Network />} />
          <Route path="/solutions/sd-wan" element={<SDWAN />} />
          <Route path="/solutions/cybersecurity" element={<Cybersecurity />} />
          
          {/* Industries */}
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/industries/credit-unions" element={<CreditUnions />} />
          <Route path="/industries/banking" element={<Banking />} />
          
          {/* Assessments */}
          <Route path="/assessments" element={<AssessmentsPage />} />
          <Route path="/assessments/cybersecurity" element={<CybersecurityAssessment />} />
          <Route path="/assessments/cloud" element={<CloudAssessment />} />
          <Route path="/assessments/network" element={<NetworkAssessment />} />
          <Route path="/assessments/data-analytics" element={<DataAnalyticsAssessment />} />
          <Route path="/assessments/ai" element={<AIAssessment />} />
          <Route path="/assessments/ucaas" element={<UCaaSAssessment />} />
          <Route path="/assessments/contact-center" element={<ContactCenterAssessment />} />
          
          {/* Legal */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          
          {/* 404 - redirect to home */}
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}

export default App

